export default "__VITE_ASSET__f6af66c8__"